module.exports = __webpack_public_path__ + "static/media/avatar.c37a0048.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/avatar.svg
// module id = 133
// module chunks = 0